import { NgClass, NgComponentOutlet, NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ProductListingComponentDef } from '@df/catalog-ui/product/listing/product-listing.component.def';
import { NgInject } from '@df/ng/ng-inject';
import { DfUiModule } from '@df/ui/df-ui.module';
import { DfModalService } from '@df/ui/modal/df-modal.service';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { IfTradeStoreDirective } from '../../../multisite/trade/if-trade-store.directive';
import { TradeClassDirective } from '../../../multisite/trade/trade-class.directive';
import { ICmsOutletBlockComponent } from '../../outlet-block/icms-outlet-block.component';
import { NProductListingFiltersModal } from './filter/filter-modal.component';
import { ProductListingSortComponent } from './product-listing-sort.component';
import { NListing } from './product-listing.interface';
import { ListingSizeComponent } from './size/listing-size.component';
import { ListingSortComponent } from './sort/listing-sort.component';

export const toggleTieredPriceModeListingEvent = 'toggleTieredPriceModeListingEvent';
@Component({
    selector: 'product-listing-tools',
    templateUrl: './product-listing-tools.html',
    standalone: true,
    imports: [
        DfUiModule,
        ICmsOutletBlockComponent,
        IfTradeStoreDirective,
        NgClass,
        NgComponentOutlet,
        NgIf,
        NgSwitch,
        NgSwitchCase,
        NgSwitchDefault,
        NgTemplateOutlet,
        PriceComponent,
        TradeClassDirective,
        TranslationModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductListingToolsComponent extends ProductListingComponentDef implements OnInit, NListing.ILisitngTotals {
    @Input()
    type: 'bulkOrder' | 'plp' = 'plp';
    @Output()
    tieredPriceModeChange = new EventEmitter();

    private _tieredPrice = true;
    @NgInject(DfModalService)
    readonly DfModalService: DfModalService | undefined;
    override ngOnInit() {
        super.ngOnInit();
        this.toggleTieredPriceMode(true);
        this.timeoutService?.setTimeout(() => this.onListingUpdate(), 0);
    }
    showFiltersModal(): void {
        this.DfModalService?.open(undefined, NProductListingFiltersModal.id, undefined, this.listing);
    }
    get noResults(): boolean {
        return this.listing.getTotal() === 0;
    }
    get tieredPrice(): boolean {
        return !!this._tieredPrice;
    }
    set tieredPrice(value: boolean) {
        this._tieredPrice = value;
        this.toggleTieredPriceMode(value);
        this.detectChanges();
    }
    private toggleTieredPriceMode(value: boolean): void {
        this.app.events.broadcast(toggleTieredPriceModeListingEvent, value);
        this.tieredPriceModeChange.emit(value);
    }
    get getTotal(): number {
        return this.listing.getTotal();
    }
    get sortOutlet() {
        return { component: ProductListingSortComponent, inputs: { sort: this.listing.sort } };
    }
    get sizeOutlet() {
        return { component: ListingSizeComponent, inputs: { size: this.listing.size } };
    }
    get bulkOrderSortOutlet() {
        return { component: ListingSortComponent, inputs: { sort: this.listing.sort } };
    }
}
